var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 20,
    viewBox: "0 0 35 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-135 -98) translate(135 98)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.5,
    height: 20,
    fill: "#3598D8",
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8.7 10.3h1.6l-.8-2-.8 2zM31 6.5h-4.1l-1 1.1-.9-1.1h-8.7l-.8 1.8-.8-1.8h-3.5v.8l-.4-.8h-3l-2.9 7h3.5l.4-1.1h1l.4 1.1h3.9v-.8l.3.8h2l.3-.9v.9h8l1-1.1.9 1.1h4.1L28.1 10 31 6.5zm-12.1 6h-1.1V8.6l-1.7 3.9h-1l-1.7-3.9v3.9h-2.3l-.4-1.1H8.3l-.4 1.1H6.6l2.1-5h1.7l1.9 4.7V7.5h1.9l1.5 3.4 1.4-3.4H19v5h-.1zm9.9 0h-1.5L26 10.8l-1.5 1.7H20v-5h4.6L26 9.1l1.5-1.6h1.4L26.7 10l2.1 2.5zm-7.7-4v.9h2.5v1h-2.5v1h2.8l1.3-1.5L24 8.5h-2.9z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/amex.d1aeef76095d422a4798bd6600f4fc19.svg";
export { ForwardRef as ReactComponent };